/**
 * Mapping between Recipes and Ausladegruppen.
 *
 * @note The interfaces in this file are more or less copied from the supabase generated types in the users-svc.
 * @todo Rename to `RecipeAnimalGroupsSchema`
 * @todo Can the `AnimalGroupSchema` be reused?
 */

import { number, object, string, type InferType } from "yup"

export const RecipesAusladegruppenSchema = object({
  ausladegruppe_id: string().required(),
  order: number().integer().min(0).required(),
  recipe_id: string().required(),
})

export const RecipesAusladegruppenCreateSchema =
  RecipesAusladegruppenSchema.omit(["recipe_id"])

export type RecipesAusladegruppen = InferType<
  typeof RecipesAusladegruppenSchema
>
export type RecipesAusladegruppenCreate = InferType<
  typeof RecipesAusladegruppenCreateSchema
>
